import { Typography } from "@mui/material";

export interface TradeDirection {
  tradeDirection: string;
}

export const TradeDirection = (props: TradeDirection) => {
  switch (props.tradeDirection?.toLowerCase()) {
    case "buy":
      return (
        <Typography color="success" variant="subtitle2" fontWeight="bold">
          BUY
        </Typography>
      );
    case "sell":
      return (
        <Typography color="error" variant="subtitle2" fontWeight="bold">
          SELL
        </Typography>
      );
    default:
      return <div />;
  }
};
